import SummaryRegistrationCourses from "../../summary-registration-courses";
import { Create } from "../../summary-registration-courses/pages/create";
import { Detail } from "../../summary-registration-courses/pages/detail";

export const summaryRegistrationCourses = {
    summaryRegistrationCourses: {
      isAdmin: false,
      title: "4. Bảng tổng hợp nhân sự tham gia khoá học",
      path: "/procedure/summary-registration-courses",
      parentId: "procedure",
      component: SummaryRegistrationCourses,
    },
    summaryRegistrationCreateCourses: {
      isAdmin: false,
      title: "4. Bảng tổng hợp nhân sự tham gia khoá học",
      path: "/procedure/summary-registration-courses/create/:id",
      parentId: "procedure",
      component: Create,
    },
    summaryRegistrationDetailCourses: {
      isAdmin: false,
      title: "4. Bảng tổng hợp nhân sự tham gia khoá học",
      path: "/procedure/summary-registration-courses/details/:id",
      parentId: "procedure",
      component: Detail,
    },
};